import { render, staticRenderFns } from "./UploadProduto.vue?vue&type=template&id=2939a3e6&scoped=true&"
import script from "./UploadProduto.vue?vue&type=script&lang=js&"
export * from "./UploadProduto.vue?vue&type=script&lang=js&"
import style0 from "./UploadProduto.vue?vue&type=style&index=0&id=2939a3e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939a3e6",
  null
  
)

export default component.exports